import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalFooter } from 'react-bootstrap';
import styled from 'styled-components';

import type { IDeleteFolderModalData } from '@/hooks/types';
import type { IResourceDeleteFolder } from '@/api/types';

import { Button } from '@/components/common';
import { useAppDispatch } from '@/hooks';
import { deleteFolder } from '@/store/slices/resourcesSlice';

interface IFolderDeleteModalProps {
  modalData: IDeleteFolderModalData;
  handleClose: () => void;
}

const FolderDeleteModal = ({ modalData, handleClose }: IFolderDeleteModalProps): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleSubmit = useCallback(async () => {
    handleClose();

    const payload: IResourceDeleteFolder = {
      id: modalData.folderId,
      name: modalData.name,
      parentId: modalData.parentFolderId,
      clientId: modalData.clientId,
      type: modalData.folderType,
      agentVisible: false,
    };

    await dispatch(deleteFolder(payload));
  }, [dispatch, handleClose, modalData]);

  return (
    <>
      <ModalBody>
        <p>{t('resources.modals.deleteWarning', { name: modalData.name })}</p>
      </ModalBody>
      <StyledModalFooter>
        <StyledButton color="blueOutline" onClick={handleClose}>
          {t`common.btnNo`}
        </StyledButton>
        <StyledButton color="blue" onClick={handleSubmit}>
          {t`common.btnYes`}
        </StyledButton>
      </StyledModalFooter>
    </>
  );
};

export { FolderDeleteModal };

const StyledButton = styled(Button)`
  flex: 1;
  margin: 0;
`;

const StyledModalFooter = styled(ModalFooter)`
  gap: 16px;
  justify-content: center;
  padding: 12px 0;
`;
